import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Table, Space, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import ConfirmationModal from "../modal/ConfirmationModal";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import moment from "moment";
import EditKpiProgressModal from "../modal/edit/EditKpiProgressModal";
import DeleteKpiProgressApi from "../../api/kpi-progress/DeleteKpiprogressApi";

function KpiProgressHistoryTable(props) {
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteProgressId, setDeleteProgressId] = useState("");
  const [editProgress, setEditProgress] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  async function deleteProgress() {
    const apiResponse = await DeleteKpiProgressApi(deleteProgressId);
    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", "Progress deleted");
      props.handleOk();
    } else {
      openNotificationError("bottomRight", "Couldn't delete. Try again later.");
    }
    setDeleteProgressId("");
  }

  const columns = [
    {
      title: "Date",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (text, record) => (
        <div>{moment(record.createdOn).format("YYYY-MM-DD")}</div>
      ),
    },
    {
      title: "Target",
      dataIndex: "target",
      key: "target",
      render: (text, record) => <div>{record.target}</div>,
    },
    {
      title: "Updated by",
      dataIndex: "addedByName",
      key: "addedByName",
      render: (name, record) => {
        // Same logic as plan history modal
        if (name) return <div>{name}</div>;
        return <div>{record.addedBy}</div>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Tooltip title={"Edit"}>
            <div
              onClick={() => {
                setEditModal(true);
                setEditProgress(record);
              }}
              className="text-blue-500 hover:text-blue-600 cursor-pointer"
            >
              <EditOutlined />
            </div>
          </Tooltip>
          <Tooltip title={"Delete"}>
            <div
              onClick={() => {
                setDeleteModal(true);
                setDeleteProgressId(record.progressId);
              }}
              className="text-red-500 hover:text-red-600 cursor-pointer"
            >
              <DeleteOutlined />
            </div>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={props.data}
        pagination={{ position: ["none"] }}
        loading={loading}
      />
      <EditKpiProgressModal
        visible={editModal}
        handleCancel={() => {
          setEditModal(false);
          setEditProgress();
        }}
        progress={editProgress}
        handleOk={() => props.handleOk()}
      />
      <ConfirmationModal
        visible={deleteModal}
        handleCancel={() => {
          setDeleteModal(false);
          setDeleteProgressId("");
        }}
        handleOk={() => deleteProgress()}
        text="Are you sure want to delete this progress?"
        title="Delete progress"
      />
    </>
  );
}

export default KpiProgressHistoryTable;
